module.exports = __webpack_public_path__ + "static/media/muted.d54149ea.png";